const registrationProductId = '00000000-0000-0000-0000-000000000001';

export {
	registrationProductId
};